var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    'background-image': `linear-gradient(${_vm.startColor}, ${_vm.endColor})`,
  })},[_c('v-container',{staticClass:"section text-left"},[_c('v-row',[_c('v-col',{staticClass:"d-none d-lg-block",attrs:{"cols":"1"}}),_c('v-col',{attrs:{"cols":_vm.$vuetify.breakpoint.name == 'lg' ? '10' : '12'}},[_c('div',[_vm._t("default")],2)]),_c('v-col',{staticClass:"d-none d-lg-block",attrs:{"cols":"1"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }